// extracted by mini-css-extract-plugin
module.exports = {"nextArrow":"nextArrow__1SEN5","prevArrow":"prevArrow__2N1k9","mobileCast":"mobileCast__e9Wd3","desktopCast":"desktopCast__3fyS0"};